import { useEffect, useState } from "react";
import "../settings.css";
import SideBar from "../Components/SideBar/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showSnackBar } from "../../../../../../store/common/snackBarSlice";
import { updateGeneralSettings } from "../../../../../../services/settings.services";
import { findSettingByType } from "../../../../../../helpers/helpers";
import { addUser } from "../../../../../../store/userSlice";
import BoltButton from "../../../../../../Components/UI/Buttons/BoltButton";
import { FiGrid, FiChevronDown } from "react-icons/fi";

const PER_PAGE_OPTIONS = [10, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200];

function TableSettings() {
  const { t } = useTranslation("settings");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [value, setValue] = useState("20");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.general_settings?.length) {
      const s = findSettingByType(user.general_settings, "perPage");
      if (s?.value) setValue(String(s.value));
    }
  }, [user]);

  const handleSave = async () => {
    setLoading(true);
    const response = await updateGeneralSettings({ setting_type: "perPage", value });
    setLoading(false);
    if (!response?.data?.success) {
      dispatch(showSnackBar({ text: t("common:messages.somethingWentWrong"), severity: "error" }));
      return;
    }
    const updatedUser = { ...user, general_settings: response.data.result };
    dispatch(addUser(updatedUser));
    localStorage.setItem("user", JSON.stringify(updatedUser));
    dispatch(showSnackBar({ text: t("common:messages.settingsUpdated"), severity: "success" }));
  };

  return (
    <div className="parent_wraper">
      <SideBar active="3_0" />
      <div className="dash_table_wrapper">
        <div className="flex items-center justify-between px-1 mb-6">
          <h2 className="text-lg font-semibold text-ui-text m-0">{t("sidebar.items.tablePagination")}</h2>
        </div>

        <div className="bg-ui-surface border border-ui-border rounded-xl p-4 max-w-xs">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg bg-brand-light flex items-center justify-center shrink-0">
              <FiGrid size={14} className="text-brand" />
            </div>
            <p className="text-sm font-semibold text-ui-text m-0">{t("table.recordsPerPage")}</p>
          </div>

          <div className="mb-4">
            <label className="block text-xs font-medium text-ui-text-muted mb-1.5">{t("table.numberOfRecords")}</label>
            <div className="relative">
              <select
                value={value}
                onChange={(e) => setValue(e.target.value)}
                className="w-full h-9 pl-3 pr-8 border border-ui-border rounded-lg text-sm text-ui-text outline-none focus:border-brand focus:ring-1 focus:ring-brand-light transition-all bg-ui-surface appearance-none"
              >
                {PER_PAGE_OPTIONS.map((v) => (
                  <option key={v} value={v}>{v}</option>
                ))}
              </select>
              <FiChevronDown size={14} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-ui-text-subtle pointer-events-none" />
            </div>
          </div>

          <BoltButton label={t("actions.saveChanges")} variant="primary" size="md" loading={loading} onClick={handleSave} />
        </div>
      </div>
    </div>
  );
}

export default TableSettings;
